import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M20.3301 11.022H9.86108C9.28108 11.022 8.80908 11.495 8.80908 12.076V12.751C8.80908 13.332 9.28108 13.803 9.86108 13.803L14.8041 13.849L14.7541 16.984L9.81608 16.938V14.724C9.81608 14.447 9.59108 14.223 9.31508 14.223C9.03908 14.223 8.81408 14.447 8.81408 14.724V16.938C8.81408 17.516 9.28708 17.986 9.86708 17.986H14.7551C15.3351 17.986 15.8071 17.516 15.8071 16.938V13.849C15.8071 13.271 15.3351 12.801 14.7551 12.801L9.81408 12.751L9.86308 12.025H20.3321C20.7001 12.025 21.0001 12.324 21.0001 12.692V15.712C21.0001 15.946 20.8901 16.103 20.7931 16.197L18.3641 18.627C18.2351 18.753 18.0671 18.822 17.8911 18.822H9.86808C9.84108 18.822 9.82408 18.802 9.82008 18.784C9.76908 18.513 9.50908 18.336 9.23408 18.386C8.96208 18.437 8.78308 18.699 8.83508 18.972C8.92908 19.466 9.36308 19.825 9.86808 19.825H17.8901C18.3291 19.825 18.7461 19.655 19.0681 19.341L21.4971 16.911C21.8221 16.593 22.0011 16.168 22.0011 15.713V12.693C22.0011 11.771 21.2521 11.022 20.3311 11.022H20.3301Z"
      fill="currentColor"
    />
    <path
      d="M11.558 4.62C11.558 4.375 11.36 4.177 11.115 4.177C6.09 4.177 2 8.269 2 13.299C2 13.543 2.198 13.741 2.443 13.741C2.688 13.741 2.886 13.543 2.886 13.299C2.886 8.757 6.578 5.063 11.115 5.063C11.359 5.063 11.558 4.865 11.558 4.62V4.62Z"
      fill="currentColor"
    />
    <path
      d="M11.558 8.089C11.558 7.844 11.36 7.646 11.115 7.646C8.00099 7.646 5.46899 10.182 5.46899 13.297C5.46899 13.541 5.66699 13.739 5.91199 13.739C6.15699 13.739 6.35499 13.541 6.35499 13.297C6.35499 10.669 8.49099 8.53 11.117 8.53C11.36 8.531 11.559 8.333 11.559 8.088L11.558 8.089Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'SimWireless');

export default Icon;
